/* eslint-disable react/no-unknown-property */
/* eslint-disable react/prop-types */
import React, { useState } from "react";

const Maintenance = ({ onLogin }) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === process.env.REACT_APP_MAINTENANCE_PASS) {
      localStorage.setItem("maintenanceAuth", "true");
      onLogin();
    } else {
      setError("Şifre yanlış!");
    }
  };

  return (
    <>
      <link
        href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.0/css/bootstrap.min.css"
        rel="stylesheet"
      />
      <link
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
        rel="stylesheet"
      />

      <div
        className="min-vh-100 d-flex align-items-center"
        style={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6 col-lg-4">
              <div
                className="card shadow-lg border-0"
                style={{ borderRadius: "20px" }}
              >
                <div className="card-body p-5 text-center">
                  <div className="mb-4">
                    <div
                      className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                      style={{
                        width: "80px",
                        height: "80px",
                        background: "linear-gradient(45deg, #FF6B6B, #4ECDC4)",
                        animation: "pulse 2s infinite",
                      }}
                    >
                      <i
                        className="fas fa-tools text-white"
                        style={{ fontSize: "2rem" }}
                      ></i>
                    </div>
                  </div>
                  <h1 className="h3 fw-bold text-dark mb-2">Site Bakımda</h1>
                  <p className="text-muted mb-4">
                    Sistem geçici olarak bakımdadır. Lütfen daha sonra tekrar
                    deneyin.
                  </p>

                  <div>
                    <div className="mb-3">
                      <div className="input-group">
                        <span className="input-group-text bg-light border-end-0">
                          <i className="fas fa-lock text-muted"></i>
                        </span>
                        <input
                          type="password"
                          className={`form-control border-start-0 ${
                            error ? "is-invalid" : ""
                          }`}
                          placeholder="Yönetici şifresi"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          style={{ paddingLeft: "10px" }}
                          onKeyPress={(e) => {
                            if (e.key === "Enter") {
                              handleSubmit(e);
                            }
                          }}
                        />
                      </div>
                      {error && (
                        <div className="text-danger mt-2 small">
                          <i className="fas fa-exclamation-triangle me-1"></i>
                          {error}
                        </div>
                      )}
                    </div>

                    <button
                      onClick={handleSubmit}
                      className="btn btn-lg w-100 text-white fw-semibold"
                      style={{
                        background: "linear-gradient(45deg, #667eea, #764ba2)",
                        border: "none",
                        borderRadius: "12px",
                        transition: "all 0.3s ease",
                      }}
                      onMouseOver={(e) => {
                        e.target.style.transform = "translateY(-2px)";
                        e.target.style.boxShadow =
                          "0 8px 25px rgba(102, 126, 234, 0.4)";
                      }}
                      onMouseOut={(e) => {
                        e.target.style.transform = "translateY(0)";
                        e.target.style.boxShadow = "none";
                      }}
                    >
                      <i className="fas fa-sign-in-alt me-2"></i>
                      Giriş Yap
                    </button>
                  </div>

                  <div className="mt-4 pt-3 border-top border-light">
                    <small className="text-muted">
                      <i className="fas fa-info-circle me-1"></i>
                      Erişim sorunu yaşıyorsanız sistem yöneticisi ile iletişime
                      geçin.
                    </small>
                  </div>
                </div>
              </div>

              <div className="text-center mt-4">
                <div className="card border-0 bg-transparent">
                  <div className="card-body py-3">
                    <div className="row text-center text-white">
                      <div className="col-4">
                        <i className="fas fa-clock fa-lg mb-2"></i>
                      </div>
                      <div className="col-4">
                        <i className="fas fa-shield-alt fa-lg mb-2"></i>
                      </div>
                      <div className="col-4">
                        <i className="fas fa-rocket fa-lg mb-2"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes pulse {
          0% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.05);
          }
          100% {
            transform: scale(1);
          }
        }

        .card {
          backdrop-filter: blur(10px);
          background: rgba(255, 255, 255, 0.95) !important;
        }

        .input-group-text {
          background: transparent !important;
          border-right: none !important;
        }

        .form-control:focus {
          border-color: #667eea !important;
          box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25) !important;
        }
      `}</style>
    </>
  );
};

export default Maintenance;
